import React from 'react';
import { Box, Skeleton } from '@mui/material';

function SectorsManagementSkeleton() {
  return (
    <Box sx={{ px: 0, py: { xs: 1, sm: 2 } }}>
      {/* Header */}
      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <Box>
          <Skeleton variant="text" width={220} height={32} animation="wave" />
          <Skeleton variant="text" width={300} height={18} animation="wave" sx={{ mt: 0.5 }} />
        </Box>
        <Skeleton variant="rounded" width={100} height={32} animation="wave" sx={{ borderRadius: 1 }} />
      </Box>

      {/* Summary Cards */}
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', sm: 'repeat(4, 1fr)' }, gap: 1.5, mb: 2 }}>
        {[1, 2, 3, 4].map((i) => (
          <Box key={i} sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2.5, bgcolor: 'background.paper' }}>
            <Skeleton variant="text" width="50%" height={14} animation="wave" sx={{ mb: 1 }} />
            <Skeleton variant="text" width="35%" height={28} animation="wave" />
          </Box>
        ))}
      </Box>

      {/* Table */}
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2.5, bgcolor: 'background.paper', overflow: 'hidden' }}>
        <Box sx={{ px: 2.5, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Skeleton variant="text" width={160} height={20} animation="wave" />
        </Box>
        <Box sx={{ display: 'flex', gap: 2, px: 2, py: 1, borderBottom: '2px solid', borderColor: 'divider' }}>
          {[30, 60, 110, 110, 50, 50, 80, 70, 30].map((w, i) => (
            <Skeleton key={i} variant="text" width={w} height={14} animation="wave" />
          ))}
        </Box>
        {Array.from({ length: 11 }).map((_, i) => (
          <Box key={i} sx={{
            display: 'flex', alignItems: 'center', gap: 2,
            px: 2, py: 1, borderBottom: i < 10 ? '1px solid' : 'none', borderColor: 'divider',
          }}>
            <Skeleton variant="text" width={20} height={18} animation="wave" />
            <Skeleton variant="text" width={55} height={18} animation="wave" />
            <Skeleton variant="text" width={100} height={18} animation="wave" sx={{ flex: 1 }} />
            <Skeleton variant="text" width={90} height={18} animation="wave" />
            <Skeleton variant="text" width={35} height={18} animation="wave" />
            <Skeleton variant="text" width={35} height={18} animation="wave" />
            <Skeleton variant="text" width={70} height={18} animation="wave" />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Skeleton variant="circular" width={7} height={7} animation="wave" />
              <Skeleton variant="text" width={55} height={16} animation="wave" />
            </Box>
            <Skeleton variant="circular" width={20} height={20} animation="wave" />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default SectorsManagementSkeleton;

